export const header = {
	selector: {
		own: '.js-header',
		logo: '.js-header-logo',
		filterHandler: '.js-filter-handler',
		actions: '.js-header-actions',
		account: '.js-header-account',
		export: {
			pdf: {
				pdfLinkExport: '.js-pdf-export',
				format: 'data-pdf-export-format',
				pdfExportLink: 'data-link-pdf-export',
				pdfExportDownloadLink: 'data-link-pdf-export-download',
			},
		},
	},
	size: {
		scrolledDiff: 20,
	},
}
